<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_STATUS" ppColor="primary-950"></pp-icon>
</div>

<span>
  <span class="notification__blue-text">{{ 'changed' | ppTranslate }}</span>
  {{ 'the' | ppTranslate }}
  <span class="notification__bold">{{ ppNotification.changeBody.label }}</span>
  {{ 'of_a_point_you' | ppTranslate }}
  {{ notificationReason }}
  {{ 'from' | ppTranslate }}
  <span class="notification__bold notificationStatus--{{ oldStatusColor }}">
    {{ oldStatusText }}
  </span>
  {{ 'to' | ppTranslate | lowercase }}
  <span class="notification__bold notificationStatus--{{ newStatusColor }}">{{
    newStatusText
  }}</span
  >.
</span>
